import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { computePublicPath } from './app/core/utils/public-path.util';

// Ensure webpack public path is correct before any lazy import runs.
declare let __webpack_public_path__: string;

const normalizePublicPath = (): string => {
  const fallbackOrigin: string = window.location.origin || `${window.location.protocol}//${window.location.host}`;
  const candidate: string = document.querySelector('base')?.href || document.baseURI || fallbackOrigin || '/';

  return computePublicPath(candidate, fallbackOrigin);
};

(() => {
  const publicPath: string = normalizePublicPath();
  // @ts-ignore - webpack global
  __webpack_public_path__ = publicPath;
})();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error(err);
  });
